import { useSelector, useDispatch } from "react-redux";
import { MdOutlinePendingActions } from "react-icons/md";
import Check from "../../assets/check.png";
import Cancel from "../../assets/cancel-order.png";
import { CiDeliveryTruck } from "react-icons/ci";
import { useEffect } from "react";
import {
  getAccepted,
  getCanceled,
  getDelivered,
  getPending,
} from "../../redux/apiCall/orderCall";

const OrderStatCard = ({ label, icon, value, valueClass = "" }) => (
  <div className="admin-stat-card">
    <span className="admin-stat-label">{label}</span>
    <div className="admin-stat-card-inner">
      <div className="admin-stat-icon">{icon}</div>
      <p className={`admin-stat-value ${valueClass}`}>{value}</p>
    </div>
  </div>
);

const OrdersCard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPending());
    dispatch(getAccepted());
    dispatch(getCanceled());
    dispatch(getDelivered());
  }, [dispatch]);

  const { pending, accepted, delivered, canceled } = useSelector(
    (state) => state.order
  );

  return (
    <div className="d-flex gap-4 flex-wrap">
      <OrderStatCard
        label="Pending Orders"
        value={pending}
        icon={<MdOutlinePendingActions className="text-white" />}
        valueClass="text-color-custom"
      />
      <OrderStatCard
        label="Accepted Orders"
        value={accepted}
        icon={<img alt="accepted" src={Check} />}
        valueClass="text-success"
      />
      <OrderStatCard
        label="Delivered Orders"
        value={delivered}
        icon={<CiDeliveryTruck className="text-white" />}
        valueClass="text-success"
      />
      <OrderStatCard
        label="Canceled Orders"
        value={canceled}
        icon={<img alt="canceled" src={Cancel} />}
        valueClass="text-danger"
      />
    </div>
  );
};

export default OrdersCard;
